import { defineStore } from "pinia";
import { UsuarioLogado } from "@/shared/models/usuario_logado";
import { ref, computed } from "vue";
import LoginResponse from "../dtos/login_response";
import { clearClientSession } from "@/shared/services/session_service";

export const useLoginStore = defineStore(
  "login",
  () => {
    const authUser = ref<LoginResponse>({
      data: {
        accessToken: "",
        refreshToken: "",
        expiresIn: "",
        permissoes: [],
        refreshTokenExpiration: "",
        drawer: false,
        userName: "",
        profileSlug: "",
        profileId: 0,
        userId: 0,
      },
    });

    const usuarioLogado = ref<UsuarioLogado>({
      email: "",
      login: "",
      cpf: "",
      nome: "",
      emailConfirmado: false,
      perfilId: 0,
      perfilUuid: "",
      perfilNome: "",
      ativo: false,
      permissoes: [],
      passwordMustToBeChanged: false,
      criadoEm: "",
      criadoPor: "",
      modificadoEm: "",
      modificadoPor: "",
      uuid: "",
    });

    const solicitacaoResetSenhaUuid = ref<string>("");

    const isAdmin = computed(() => {
      return usuarioLogado.value.perfilId === 1;
    });

    function setAccessToken(accessToken: string) {
      sessionStorage.setItem("access_token", accessToken);
    }

    function setAuthUser(authenticationResponse: LoginResponse) {
      authUser.value = authenticationResponse;
    }

    function setRefreshToken(refreshToken: string) {
      sessionStorage.setItem("refresh_token", refreshToken);
    }

    function setRefreshTokenExpiration(refreshTokenExpiration: string) {
      sessionStorage.setItem(
        "refresh_token_expiration",
        refreshTokenExpiration
      );
    }
    function setDrawer(drawer: boolean): void {
      authUser.value.data.drawer = drawer;
      sessionStorage.setItem("drawer", drawer.toString());
    }

    function logout(): void {
      setDrawer(false);
      clearClientSession();
    }
    return {
      authUser,
      usuarioLogado,
      solicitacaoResetSenhaUuid,
      isAdmin,
      setAccessToken,
      setAuthUser,
      setRefreshToken,
      setRefreshTokenExpiration,
      setDrawer,
      logout,
    };
  },
  {
    persist: true,
  }
);
